export interface ConfigRoot {
  Features: ConfigFeature[];
}

export interface ConfigFeature {
  ID: string;
  Name: string;
  SettingsGroups: SettingsGroups[];
}

export interface SettingsGroups {
  Type: string;
  Name: string;
  ListName: string;
  Destination: string;
  Settings: Settings[];
}

export interface FixedChoice {
  FixedChoiceValue: string;
  Value: string;
  FixedChoiceName: string;
  FixedChoiceRange: string;
}

export enum FieldType {
  FixedChoice, // show dropdown containing the FixedChoiceValues
  Color, // show hex color selector control
  Boolean, // show check
  Path, // show file path selection popup
  CheckBox, // show multi-select dropdown
  Slider, // show slider component
  RadioButton, // show radio button (single selection)
  TextBox, // show textbox
}

export interface Settings {
  Type: string;
  Name: string;
  ListName: string;
  Description: string;
  InitValue: string;
  FieldType: FieldType;
  FixedChoices: FixedChoice[];
  MediaName: string;
}
